<template>
  <div class="app-root">
    <p-header />
    <div class="body-container">
      <div class="content-container" :class="{ 'content-container--home': $route.path === '/' }">
        <slot />
      </div>
    </div>
    <p-footer />
  </div>
</template>

<script setup lang="ts">
import PHeader from './PHeader/index.vue'
import PFooter from './PFooter/index.vue'
</script>

<style lang="scss" scoped>
@use '@/styles/utils/breakpoints';

.app-root {
  padding-top: 64px;
}

.body-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

.content-container {
  width: 100%;
  max-width: 1200px;
  padding: 0 96px;

  &--home {
    max-width: none;
    padding: 0;
  }

  @include breakpoints.media-breakpoint-down(md) {
    padding: 24px 16px;
  }
}
</style>
